import { Controller } from "@hotwired/stimulus"

const LOCK_EVENT = "voice-input:lock"
const UNLOCK_EVENT = "voice-input:unlock"

// Connects to data-controller="voice-input"
export default class extends Controller {
  static targets = ["textarea", "button"]

  connect() {
    this.isListening = false
    this.lockedByOther = false

    this.boundLock = this.handleLock.bind(this)
    this.boundUnlock = this.handleUnlock.bind(this)
    document.addEventListener(LOCK_EVENT, this.boundLock)
    document.addEventListener(UNLOCK_EVENT, this.boundUnlock)

    const SpeechRecognition =
      window.SpeechRecognition ||
      window.webkitSpeechRecognition

    if (!SpeechRecognition) {
      console.error("Web Speech API no soportada")
      if (this.hasButtonTarget) {
        this.buttonTarget.disabled = true
        this.buttonTarget.title = "Reconocimiento de voz no soportado"
      }
      return
    }

    this.recognition = new SpeechRecognition()

    this.recognition.lang = "es-AR"
    this.recognition.interimResults = false
    this.recognition.continuous = true

    this.recognition.onresult = (event) => {
      const transcript =
        event.results[event.results.length - 1][0].transcript

      this.insertAtCursor(`${transcript} `)
    }

    this.recognition.onerror = (event) => {
      console.error("Error reconocimiento voz:", event.error)
    }

    this.recognition.onend = () => {
      if (this.isListening) {
        this.recognition.start()
      }
    }
  }

  disconnect() {
    document.removeEventListener(LOCK_EVENT, this.boundLock)
    document.removeEventListener(UNLOCK_EVENT, this.boundUnlock)

    if (this.recognition && this.isListening) {
      this.isListening = false
      this.recognition.stop()
      document.dispatchEvent(new CustomEvent(UNLOCK_EVENT))
    }
  }

  toggle() {
    if (!this.recognition || this.lockedByOther) return

    if (this.isListening) {
      this.stop()
    } else {
      this.start()
    }
  }

  start() {
    this.recognition.start()

    this.isListening = true

    document.dispatchEvent(
      new CustomEvent(LOCK_EVENT, { detail: { source: this.element } })
    )

    if (this.hasButtonTarget) {
      this.buttonTarget.classList.remove("btn-outline-primary")
      this.buttonTarget.classList.add("btn-danger")
      this.buttonTarget.title = "Detener dictado"
    }
  }

  stop() {
    this.isListening = false

    this.recognition.stop()

    document.dispatchEvent(new CustomEvent(UNLOCK_EVENT))

    if (this.hasButtonTarget) {
      this.buttonTarget.classList.remove("btn-danger")
      this.buttonTarget.classList.add("btn-outline-primary")
      this.buttonTarget.title = "Iniciar dictado"
    }
  }

  handleLock(event) {
    if (event.detail?.source === this.element) return

    this.lockedByOther = true

    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true
      this.buttonTarget.title = "Hay otro dictado en curso"
    }
  }

  handleUnlock() {
    this.lockedByOther = false

    if (this.hasButtonTarget && this.recognition) {
      this.buttonTarget.disabled = false
      this.buttonTarget.title = "Iniciar dictado"
    }
  }

  insertAtCursor(text) {
    const trixEditor = this.element.querySelector("trix-editor")

    if (trixEditor?.editor) {
      trixEditor.editor.insertString(text)
      trixEditor.focus()
      return
    }

    if (!this.hasTextareaTarget) return

    const textarea = this.textareaTarget

    const start = textarea.selectionStart
    const end = textarea.selectionEnd

    textarea.setRangeText(
      text,
      start,
      end,
      "end"
    )

    textarea.dispatchEvent(
      new Event("input", { bubbles: true })
    )

    textarea.focus()
  }
}
